document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('loaded');

  // ファーストビューセクションの遅延読み込みを強制解除
  var sections = ['.collections-tab', '.collections-rank', '.slider-top', '.slider-sub'];
  sections.forEach(function(sel) {
    var el = document.querySelector(sel);
    if (!el) return;
    el.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.setAttribute('loading', 'eager');
    });
  });

  // MutationObserverでJS動的生成画像もeager化
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        var imgs = node.querySelectorAll ? node.querySelectorAll('img[loading="lazy"]') : [];
        imgs.forEach(function(img) {
          var parent = img.closest('.collections-tab, .collections-rank, .slider-top, .slider-sub');
          if (parent) img.setAttribute('loading', 'eager');
        });
      });
    });
  });

  var main = document.getElementById('MainContent');
  if (main) observer.observe(main, { childList: true, subtree: true });

  // 5秒後にobserver停止（初期ロード完了後は不要）
  setTimeout(function() { observer.disconnect(); }, 5000);
});
